
import { useState, useMemo, useEffect } from "react";
import ThemeModal from "../../../components/cmp/ThemeModal";
import countryList from "react-select-country-list";
import { State } from "country-state-city";
import { Formik } from "formik";
import * as Yup from "yup";
import Select from "react-select";
import { GetSettings, Alerts } from "../../../helpers";
const EditShippingZone = ({show, handleHide, zoneDetails, getShippingZone}) => {
  const [states, setStates] = useState([]);
  const options = useMemo(() => countryList().getData(), []);
  const [selectAllStates, setSelectAllStates] = useState(false);


  const handleCountryChange = (option, setFieldValue) => {
    const countryCode = option ? option.value : '';
    const countryName = option ? option.label : '';

    setFieldValue('country_code', countryCode);
    setFieldValue('country_name', countryName);

    if (countryCode) {
      const statesData = State.getStatesOfCountry(countryCode);
      const newStatesOptions = statesData.map((s) => ({
        value: s.isoCode,
        label: s.name,
      }));
      setStates(newStatesOptions);
      setSelectAllStates(true);
      setFieldValue('states', newStatesOptions);
    } else {
      setStates([]);
      setSelectAllStates(false);
      setFieldValue('states', []);
    }
  };


  const handleStateChange = (selectedOptions, setFieldValue) => {
    setFieldValue('states', selectedOptions || []);
    setSelectAllStates(false);
  };

  const handleCheckboxChange = (e, setFieldValue) => {
    const isChecked = e.target.checked;
    setSelectAllStates(isChecked);
    setFieldValue('states', isChecked ? states : []);
  };



  const validationSchema = Yup.object().shape({
    country_code: Yup.string().required('Country is required'),
    states: Yup.array()
      .of(
        Yup.object().shape({
          value: Yup.string().required(),
          label: Yup.string().required(),
        })
      )
      .min(1, 'At least one state is required'),
  });


  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
   
    const resp = await GetSettings.updateShippingZone(zoneDetails.id, values);
    
    if (resp && resp.status) {
        Alerts.alertMessage(resp.message, 'top-right', 'success');
        setSubmitting(false);
        resetForm();
        getShippingZone();
        handleHide();
    } else {
        Alerts.alertMessage(resp.message, 'top-right', 'error');
        setSubmitting(false);
    }
  }
useEffect(() => {
  if (zoneDetails?.country_code) {
    const statesData = State.getStatesOfCountry(zoneDetails.country_code);
    const newStatesOptions = statesData.map((s) => ({
      value: s.isoCode,
      label: s.name,
    }));
    setStates(newStatesOptions);

    // Check if all states were preselected
    const selectedStates = zoneDetails?.shipping_zone_reasons?.map((s) => ({
      value: s.reason_code,
      label: s.reason_name,
    })) || [];

    if (selectedStates.length === newStatesOptions.length) {
      setSelectAllStates(true);
    }
  }
}, [zoneDetails]);

  return (
    <>
    <ThemeModal show={show} handleHide={handleHide} title={'Update Shipping Zone'}>
  <Formik
        enableReinitialize={true}
        initialValues={{
          country_code: zoneDetails.country_code,
          country_name: zoneDetails.country_name,
            states: zoneDetails?.shipping_zone_reasons?.map((s) => ({
      value: s.reason_code,
      label: s.reason_name,
    })) || []
        }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleSubmit,
          isSubmitting,
          setFieldValue,
        }) => (
          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-md-12">
                <div className="form-group">
                  <label>Select Country</label>
                  <Select
                    options={options}
                    value={
                      values.country_code
                        ? { value: values.country_code, label: values.country_name }
                        : null
                    }
                    onChange={(option) => handleCountryChange(option, setFieldValue)}
                    onBlur={handleBlur}
                    name="country_code"
                    placeholder="Select a country"
                  />
                  {errors.country_code && touched.country_code && (
                    <div className="text-danger">{errors.country_code}</div>
                  )}
                </div>

                {/* {values.country_code && states.length > 0 && (
                  <div className="form-group form-check">
                    <input
                      type="checkbox"
                      className="form-check-input auto-h"
                      id="selectAllStates"
                      checked={selectAllStates}
                      onChange={(e) => handleCheckboxChange(e, setFieldValue)}
                    />
                    <label className="form-check-label" htmlFor="selectAllStates">
                      Select All States
                    </label>
                  </div>
                )} */}

                {
                   <div className="form-group">
                    <label>State / Region</label>
                    <Select
                      options={states}
                      isMulti
                      value={values.states}
                      onChange={(options) => handleStateChange(options, setFieldValue)}
                      onBlur={handleBlur}
                      name="states"
                      placeholder="Select state(s) / region(s)"
                      isDisabled={!values.country_code}
                      isClearable
                      closeMenuOnSelect={false}
                    />
                    {errors.states && touched.states && (
                      <div className="text-danger">{errors.states}</div>
                    )}
                    {values.states && values.states.length > 0 && (
                      <small className="text-muted">
                        Selected: {values.states.length} state(s)
                      </small>
                    )}
                  </div>
                }

                <div className="text-center">
                  <button
                    type="submit"
                    className="btn btn-primary btn-block"
                    disabled={isSubmitting || !values.country_code}
                    style={{
                      width: "100%",
                      maxWidth: "150px",
                    }}
                  >
                    {isSubmitting ? "Submitting..." : "Submit"}
                  </button>
                </div>
              </div>
            </div>
          </form>
        )}
      </Formik>
    </ThemeModal>
    
    </>
  );
};

export default EditShippingZone;
